<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
    </div>

    <!-- Modal close -->
    <div class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default" v-show="(ProgexctimeModal || detailModal || deleteModal)" @click="ProgexctimeModal = false, detailModal = false, deleteModal = false"></div>

    <!-- Form Modal -->
    <vue-final-modal
    v-model="ProgexctimeModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'add-modal bg-darkmode-base transition-colors duration-1000' : 'add-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal header -->
    <div class="modal-head">
        <h1 v-if="showEdit">{{ $t('progexctime.editform') }}</h1>
        <h1 v-else>{{ $t('progexctime.addform') }}</h1>

        <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="ProgexctimeModal = false"
        />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
        <progexctime-form
        :prop-class="ProgexctimeObject"
        :programme-id="programmeId"
        :show-edit="showEdit"
        @close-modal="hideModal"
        @refresh-list="refresh"
        @reset-modal="resetModal"
        />
    </div>
    </vue-final-modal>

    <!-- Detail modal -->
    <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal header -->
    <div class="modal-head">
        <h1>{{ $t('progexctime.detail') }}</h1>

        <jb-button class="btn-close-modal" :icon="mdiClose" @click="detailModal = false" />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
        <progexctime-detail
            :prop-class="ProgexctimeObject"
            @close-modal="hideModal"
        />
    </div>
    </vue-final-modal>

    <!-- Delete Modal -->
    <vue-final-modal
    v-model="deleteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal header -->
    <div class="modal-head">
        <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

        <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
        <div class="warning">{{ $t('menu.warning') }}</div>

        <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
        <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirm" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="cancel" class="btn-reset form-noicon-btn" />
        </jb-buttons>
    </div>
    </vue-final-modal>
    <!-- Main section -->
    <main-section class="overflow-x-hidden">

        <!-- Add button -->
        <jb-button label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addProgexctime()" class="ml-4 w-auto px-8 py-2 md:hidden" />

        <!-- Table data -->
        <card-component class="relative mt-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600" :title="$t('progexctime.title')" :icon="mdiCalendar" has-table>
            <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addProgexctime()"
                class="py-1 px-5 shadow-lg mt-1 w-auto absolute right-4 top-1 hidden md:flex">
            </jb-button>
            <ag-grid-vue style="width: 100%; height: 70vh;"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :pagination="true"
                :context="context"
                @grid-ready="onGridReady"
                overlayNoRowsTemplate="<span>No rows to display</span>"
                :rowData="rowData.value">
            </ag-grid-vue>
        </card-component>
    </main-section>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import { onMounted, ref, reactive, onUpdated, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { mdiCalendar, mdiCircleEditOutline, mdiTrashCan, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
import MainSection from '@/components/MainSection'
import HeroBar from '@/components/HeroBar'
import TitleBar from '@/components/TitleBar'
import ModalBox from '@/components/ModalBox'
import JbButtons from '@/components/JbButtons'
import Divider from '@/components/Divider'
import JbButton from '@/components/JbButton'
import CardComponent from '@/components/CardComponent'
import { useToast } from 'vue-toastification'
import ProgexctimeForm from '@/views/humanresource/programmeexceptiontime/ProgrammeExceptionTimeForm'
import ProgexctimeDetail from '@/views/humanresource/programmeexceptiontime/ProgrammeExceptionTimeDetail'
import Field from '@/components/Field'
import Control from '@/components/Control'
import { AgGridVue } from 'ag-grid-vue3'
import { useI18n } from 'vue-i18n'
import ButtonActionRender from '@/components/ButtonActionRender'
import ButtonActive from '@/components/ButtonActive'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
    components: {
        MainSection,
        Loading,
        TitleBar,
        CardComponent,
        HeroBar,
        ProgexctimeDetail,
        ProgexctimeForm,
        ModalBox,
        JbButton,
        JbButtons,
        Divider,
        AgGridVue,
        Control,
        Field,
        ButtonActive,
        ButtonActionRender
    },
    props: {
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        programmeId: {
            type: String,
            default: ''
        },
    },

    setup(props, { emit }) {
        // state validation
        const { t } = useI18n()
        const isLoading = ref(false)
        const rowData = reactive({})
        const filter = reactive({
            id: '',
            programme_id: '',
            description: '',
            remarks: '',
            start_date: '',
            end_date: '',
            start_work_time: '',
            end_work_time: '',
            consider_as_overtime: false
        })
        const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
        const store = useStore()
        const toast = useToast()
        const ProgexctimeModal = ref(false)
        const detailModal = ref(false)
        const deleteModal = ref(false)
        const ProgexctimeObject = ref({})
        const programmeId = ref(props.programmeId)
        const showEdit = ref(false)
        const confirm = () => confirmDelete()
        const cancel = () => deleteModal.value = false

        const columnDefs = [
            { headerName: '#', valueGetter: 'node.rowIndex+1', minWidth: 50 },
            { field: 'programme_name', headerName: t('progexctime.programme_name'), sortable: true, filter: true, minWidth: 150 },
            { field: 'description', headerName: t('progexctime.description'), sortable: true, filter: true, minWidth: 150 },
            { field: 'remarks', headerName: t('progexctime.remarks'), sortable: true, filter: true, minWidth: 150 },
            { field: 'start_date', headerName: t('progexctime.start_date'), sortable: true, filter: true, minWidth: 150 },
            { field: 'end_date', headerName: t('progexctime.end_date'), sortable: true, filter: true, minWidth: 150 },
            { field: 'start_work_time', headerName: t('progexctime.start_work_time'), sortable: true, filter: true, minWidth: 150 },
            { field: 'end_work_time', headerName: t('progexctime.end_work_time'), sortable: true, filter: true, minWidth: 150 },
            { field: 'consider_as_overtime', headerName: t('progexctime.consider_as_time'), sortable: true, filter: true, minWidth: 150, valueFormatter: params => params.value ? 'Yes' : 'No' },
            { field: 'id', headerName: t('main.action'), sortable: true, filter: true, minWidth: 165, cellRenderer: 'ButtonActionRender' }
        ]

        const defaultColDef = {
            resizable: true
        }

        const refresh = async () => {
            isLoading.value = true
            const url = props.programmeId ? `progexctime?programme_id=${props.programmeId}` : 'progexctime'
            await axios
                .get(url)
                .then(response => {
                    rowData.value = response.data.data
                    isLoading.value = false
                })
                .catch(error => {
                    toast.error(error.response.data, { timeout: 5000 })
                    console.log(error)
                    isLoading.value = false
                })
        }

        onMounted(() => {
            // refresh()
        })

        watch(() => props.programmeId, (newVal, oldVal) => {
            refresh()
        })

        const hideModal = () => {
            ProgexctimeModal.value = false
            refresh()
        }

        const showModal = () => {
            ProgexctimeModal.value = !ProgexctimeModal.value
        }

        const resetModal = () => {
            Object.assign(filter, {
                id: '',
                // programme_id: '',
                description: '',
                remarks: '',
                start_date: '',
                end_date: '',
                start_work_time: '',
                end_work_time: '',
                consider_as_overtime: false
            })
        }

        const addProgexctime = () => {
            showModal()
            resetModal()
            showEdit.value = false
            // ProgexctimeObject.value = { ...filter }
            ProgexctimeObject.value = filter
            programmeId.value = props.programmeId
        }

        const detailData = (event, data) => {
            detailModal.value = true
            ProgexctimeObject.value = data
        }

        const editData = (event, data) => {
            showModal()
            ProgexctimeObject.value = { ...data } // Pastikan data dikloning agar tidak mengubah data asli
            programmeId.value = props.programmeId
            console.log('ProgexctimeObject.value', ProgexctimeObject.value)
            showEdit.value = true
        }

        const deleteModalShow = (value) => {
            deleteModal.value = true
            console.log('deleteModal.value', value)
            deleteModal.id = value
        }

        const confirmDelete = () => {
            axios
                .delete(`progexctime/${deleteModal.id}`)
                .then(response => {
                    if (response.data.success) {
                        refresh()
                        toast.success(response.data.message, { timeout: 5000 })
                    } else {
                        toast.error(response.data.message, { timeout: 5000 })
                    }
                    deleteModal.value = false
                })
                .catch(error => {
                    toast.error(error.response?.data?.message || 'Failed to delete', { timeout: 5000 })
                    console.log(error)
                    deleteModal.value = false
                })
        }

        return {
            isLoading,
            ProgexctimeObject,
            showEdit,
            ProgexctimeModal,
            programmeId,
            addProgexctime,
            hideModal,
            showModal,
            detailModal,
            detailData,
            editData,
            mdiCalendar,
            mdiClose,
            mdiCircleEditOutline,
            mdiTrashCan,
            mdiPlusCircleOutline,
            toast,
            refresh,
            rowData,
            filter,
            columnDefs,
            defaultColDef,
            t,
            gridApi: null,
            gridColumnApi: null,
            ButtonActionRender,
            deleteModal,
            deleteModalShow,
            confirm,
            cancel,
            confirmDelete,
            resetModal,
            isAsideMobileExpanded
        }
    },
    beforeMount() {
        this.context = {
            componentParent: this
        }
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.gridColumnApi = params.columnApi
            const allColumnIds = []
            this.gridColumnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.colId)
            })
            this.gridColumnApi.autoSizeColumns(allColumnIds, false)
        }
    }
}
</script>